<template>
  <div class="index">
    <div class="info">
      <div v-for="item in info" :key="item.title">
        <div class="title">{{ item.title }}</div>
        <div class="item" v-for="_item in item.moduleInfo" :key="_item.title"
             @click.stop="routerTo(_item.routerName,_item.title)">
          {{ _item.title }}
          <img src="../assets/img/right.png" alt="icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {onMounted} from "@vue/composition-api";

export default {
  setup(props, {root}) {
    /**
     * @Description 获取跳转信息调用接口
     * @param {}
     * @return {}
     * @author Jerry
     * @date 2022/5/18
     */

    const info = [
      {
        title: '用户基本信息',
        moduleInfo: [
          {
            title: '手机号码',
            routerName: 'phone'
          },
          {
            title: '昵称',
            routerName: 'info'
          },
          {
            title: '头像',
            routerName: 'info'
          },
          // {
          //   title: '性别',
          //   routerName: 'info'
          // },
          // {
          //   title: '地区',
          //   routerName: 'info'
          // },
          // {
          //   title: '生日',
          //   routerName: 'info'
          // },
          {
            title: '第三方平台账号',
            routerName: 'third'
          },

        ]
      },
      {
        title: '用户身份信息',
        moduleInfo: [
          {
            title: '身份证相关信息',
            routerName: 'id'
          }
        ]
      },
      {
        title: '用户使用过程信息',
        moduleInfo: [
          {
            title: '播放记录',
            routerName: 'playRecord'
          },
          {
            title: '发布记录',
            routerName: 'releaseRecord'
          },
          {
            title: '交流互动记录',
            routerName: 'interaction'
          },
          {
            title: '收货信息',
            routerName: 'getInfo'
          },
          {
            title: '交易记录',
            routerName: 'payRecord'
          },
        ]
      },

      {
        title: '位置信息',
        moduleInfo: [
          {
            title: '地理位置信息',
            routerName: 'geoInfo'
          },
        ]
      },
      {
        title: '设备信息',
        moduleInfo: [
          {
            title: '设备标识信息',
            routerName: 'eqInfo'
          },
          {
            title: '设备参数与系统信息',
            routerName: 'eqSys'
          },
        ]
      }
    ]
    const routerTo = (apiName, title) => {
      root.$router.push({
        name: 'about', query: {apiName}
      })
      document.title = title
    }
    onMounted(() => {
      // console.log(root.$route);
    })
    return {
      routerTo,
      info
    }
  }
}

</script>


<style scoped lang="scss">
.index {
  width: 100%;
  height: 100%;

  .info {
    .title {
      width: 100%;
      height: 100px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC sans-serif;
      font-weight: 400;
      color: #909399;
      line-height: 44px;
      box-sizing: border-box;
      padding-left: 30px;
      padding-top: 8px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background: #F6F7F9;;
    }

    .item {
      width: 100%;
      height: 100px;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC sans-serif;
      font-weight: 400;
      color: #222222;
      line-height: 42px;
      padding: 0 30px 0 30px;
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      align-items: center;
      position: relative;
      background-color: #fff;

      img {
        width: 30px;
        height: 30px;
      }

      &:after {
        display: block;
        content: '';
        position: absolute;
        left: 30px;
        bottom: 0;
        height: 1px;
        width: calc(100% - 60px);
        background-color: #F6F7F9;
      }

      &:last-of-type {
        &:after {
          display: none;
        }
      }
    }
  }
}
</style>
